type AvatarToneToken = {
  background: string;
  color: string;
};

const lightAgilityAvatarTones: Record<
  'default' | 'primary' | 'secondary' | 'muted' | 'contrast',
  AvatarToneToken
> = {
  default: {
    background: 'var(--p-surface-200)',
    color: 'var(--p-surface-700)',
  },
  primary: {
    background: 'var(--p-primary-100)',
    color: 'var(--p-primary-700)',
  },
  secondary: {
    background: 'var(--p-surface-200)',
    color: 'var(--p-surface-700)',
  },
  muted: {
    background: 'var(--p-surface-100)',
    color: 'var(--p-surface-600)',
  },
  contrast: {
    background: 'var(--p-surface-800)',
    color: 'var(--p-surface-0)',
  },
};

const darkAgilityAvatarTones: Record<
  'default' | 'primary' | 'secondary' | 'muted' | 'contrast',
  AvatarToneToken
> = {
  default: {
    background: 'var(--p-surface-700)',
    color: 'var(--p-surface-0)',
  },
  primary: {
    background: 'var(--p-primary-700)',
    color: 'var(--p-primary-100)',
  },
  secondary: {
    background: 'var(--p-surface-700)',
    color: 'var(--p-surface-100)',
  },
  muted: {
    background: 'var(--p-surface-800)',
    color: 'var(--p-surface-400)',
  },
  contrast: {
    background: 'var(--p-surface-0)',
    color: 'var(--p-surface-900)',
  },
};

export const avatarTheme = {
  colorScheme: {
    light: {
      extend: {
        agility: {
          tone: lightAgilityAvatarTones,
        },
      },
      root: {
        background: lightAgilityAvatarTones.default.background,
        color: lightAgilityAvatarTones.default.color,
      },
    },
    dark: {
      extend: {
        agility: {
          tone: darkAgilityAvatarTones,
        },
      },
      root: {
        background: darkAgilityAvatarTones.default.background,
        color: darkAgilityAvatarTones.default.color,
      },
    },
  },
  css: ({ dt }: any) =>
    (['default', 'primary', 'secondary', 'muted', 'contrast'] as const)
      .map(
        (tone) => `
    .agility-avatar--tone-${tone}.p-avatar {
      background: ${dt(`avatar.agility.tone.${tone}.background`)};
      color: ${dt(`avatar.agility.tone.${tone}.color`)};
    }`
      )
      .join(''),
};
